import { QBox } from '@qualio/ui-components';
import { useMemo } from 'react';
import { Trans } from 'react-i18next';
import { getAttachmentUrl } from '../../../../util/UrlUtils';

export const FileDocumentPreviewError: React.FC<{
  attachmentId: string;
}> = ({ attachmentId }) => {
  const attachmentUrl = useMemo(() => {
    return getAttachmentUrl(attachmentId);
  }, [attachmentId]);

  const downloadAttachmentUrl = useMemo(
    () => getAttachmentUrl(attachmentId, true),
    [attachmentId],
  );

  return (
    <QBox>
      <Trans
        i18nKey="errors.unsupportedPreviewWithActions"
        components={{
          br: <br />,
          openLink: (
            // eslint-disable-next-line jsx-a11y/anchor-has-content
            <a target="_blank" rel="noopener noreferrer" href={attachmentUrl} />
          ),
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          downloadLink: <a href={downloadAttachmentUrl} />,
        }}
      />
    </QBox>
  );
};
